import { render, staticRenderFns } from "./drawer-view.vue?vue&type=template&id=32b59f6a&scoped=true&"
import script from "./drawer-view.vue?vue&type=script&lang=js&"
export * from "./drawer-view.vue?vue&type=script&lang=js&"
import style0 from "./drawer-view.vue?vue&type=style&index=0&id=32b59f6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b59f6a",
  null
  
)

export default component.exports